import { useEffect, useRef, useCallback } from 'react';
import './confirmDialog.css';

export default function ConfirmDialog({ visible, onConfirm, onCancel, message }) {
  const dialogRef = useRef(null);
  const confirmBtnRef = useRef(null);
  const previousFocusRef = useRef(null);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onCancel();
      return;
    }

    if (e.key === 'Tab' && dialogRef.current) {
      const focusable = dialogRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }, [onCancel]);

  useEffect(() => {
    if (visible) {
      previousFocusRef.current = document.activeElement;
      setTimeout(() => confirmBtnRef.current?.focus(), 0);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      if (!visible && previousFocusRef.current) {
        previousFocusRef.current.focus();
      }
    };
  }, [visible, handleKeyDown]);

  if (!visible) return null;

  return (
    <div
      className="confirm-dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-message"
      ref={dialogRef}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="confirm-dialog-box">
        <p id="confirm-dialog-message">{message}</p>
        <div className="confirm-dialog-buttons">
          <button
            onClick={onConfirm}
            className="confirm-dialog-confirm"
            ref={confirmBtnRef}
          >
            Yes
          </button>
          <button onClick={onCancel} className="confirm-dialog-cancel">No</button>
        </div>
      </div>
    </div>
  );
}
